import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rule-of-72',
  component: () => import('../../routes/RuleOf72Calculator.svelte'),
  card: {
    id: 'rule-of-72',
    title: 'Rule of 72',
    description: 'Estimate how many years it takes for an investment to double using the Rule of 72 approximation.',
    icon: 'calculate',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/rule-of-72',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Rule of 72 Calculator – Free Investment Doubling Time Estimator',
    description: 'Free Rule of 72 calculator. Instantly estimate how many years it takes for an investment to double at any annual return rate. Also shows the exact calculation vs the Rule of 72 approximation.',
  },
};

export default meta;